import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GIFTING_QUERY_PARAM, VA_QUERY_PARAM } from 'Utils/Constants';
import { SmartLink } from 'Components/SmartLink';
import { isSignUpPage, isSignUpPlans } from 'Utils/Path';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { useStore } from 'Hooks/useStore';
import './UserMenu.css';

const trackMenuEvent = (itemTitle) =>
  trackEvent(TRACKING_ENUMS.EVENT_GLOBAL_NAV_CLICK, {
    page_item_title: itemTitle,
  });

const UserMenuItem = (itemProps) => (
  <li className="userMenuPanelItem" role="menuitem">
    <SmartLink className="userListLink" onClick={() => trackMenuEvent(itemProps.text)} {...itemProps} />
  </li>
);

const UserMenuComponent = (props) => {
  const user = useStore('user');
  const { routes, defaultConfig } = useStore('appConfig');
  const isGifting = useStore('purchaseMode.isGifting');

  const { pathname, locationSearch, segmentProps } = props;

  const urlParams = new URLSearchParams(locationSearch);
  const vaMemberId = urlParams.get(VA_QUERY_PARAM);

  const [isOpen, setIsOpen] = useState(false);
  const [isClickedToOpen, setIsClickedToOpen] = useState(false);

  const { showSignInHeader, rootDomain, helpCenterPage } = defaultConfig;
  const getHoverState = () => {
    if (isOpen && isClickedToOpen) {
      return 'open';
    }
    if (isOpen) {
      return '';
    } else return 'close';
  };
  const hoverState = getHoverState();

  const clickToggle = () => {
    setIsOpen((prevState) => !prevState);
    setIsClickedToOpen((prevState) => !prevState);
  };

  const handleOnMouseEnter = () => {
    setIsOpen(true);
    setIsClickedToOpen(false);
  };

  const closePanel = () => {
    setIsOpen(false);
    setIsClickedToOpen(false);
  };

  const getSignInSearch = () => {
    let search = '';
    if (isGifting) {
      search = GIFTING_QUERY_PARAM;
    } else if (vaMemberId) {
      search = `${VA_QUERY_PARAM}=${vaMemberId}`;
    } else if (isSignUpPage(pathname)) {
      search = `return_to=${pathname}${locationSearch}`; //includes params
    }
    return search;
  };

  if (user.isAuthenticated || user.hasMvpd) {
    return (
      <button
        type="button"
        className="userMenu"
        onClick={clickToggle}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={closePanel}
        role="menu"
      >
        <div className="userLabel" role="menuitem">
          <img
            className="profileIcon"
            src="/account/static/images/FN/profile-icon.svg"
            width="20"
            height="20"
            alt="My Account"
          />
          <img
            className="profileIconArrow"
            src="/account/static/images/FN/down-arrow.svg"
            width="12"
            height="12"
            alt="My Account"
          />
        </div>
        <div className={`hoverPanel ${hoverState}`}>
          <ul className="userMenuPanelList">
            <UserMenuItem text="Home" linkUrl={rootDomain} reload />
            <UserMenuItem text="My Account" linkUrl={routes.myAccount} />
            <UserMenuItem text="Help" linkUrl={helpCenterPage} reload />
            <UserMenuItem text="Sign Out" linkUrl={routes.signout} />
          </ul>
        </div>
      </button>
    );
  }

  if (showSignInHeader) {
    const isSignUp = isSignUpPlans(pathname);
    return (
      <div className={`userMenu${isSignUp ? ' hasVariant' : ''}`}>
        <Link
          className="userLabel"
          role="menuitem"
          to={{
            pathname: routes.signin,
            search: getSignInSearch(),
            state: {
              page_source: (segmentProps && segmentProps.page_start_source) || 'general',
            },
          }}
          onClick={() => trackMenuEvent('Sign in')}
        >
          Sign in
        </Link>
      </div>
    );
  }

  return null;
};

export default UserMenuComponent;
